exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".yxtbiz-ai-robot-click-jump[data-v-a53ac9ce]{display:flex;align-items:center;height:28px;padding:0 12px}\n", ""]);

